import React, { useState, useEffect } from 'react';
import { Button, Modal, Spin } from 'antd';
import { fetchMyprofile, updateMyprofile } from '../../global/utility/Utils';
import ValidationIcon, { ErrorMessage, getInputClassNamesUser } from '../../global/components/ValidationIcon';
import { MAX_CHAR_LIMITS, getCharLimitMsgIfExceeded } from "../../global/constants/inputLimits";
import ToastNotification from "../../global/components/ToastNotification";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { logout, updateAuth } from "../../store/actions/auth";
import { useDispatch } from 'react-redux';


const MyProfile = ({ visible, onClose }) => {
  const dispatch = useDispatch();

  const [hovered, setHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
  });
  const [errors, setErrors] = useState({
    firstName: "initial",
    lastName: "initial",
    email: "initial",
    mobileNumber: "initial",
  });
  const [msgNotific, setMsgNotific] = useState('');
  const [typeNotific, setTypeNotific] = useState('error');
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const nameRegex = /^[A-Za-z0-9 _]+$/;

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      try {
        const data = await fetchMyprofile();
        setFormData({
          firstName: data?.firstname,
          lastName: data?.lastname,
          email: data?.email,
          mobileNumber: data?.mdn,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    getData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    let tempErrors = { ...errors };
    switch (name) {
      case "firstName":
       // tempErrors.firstName = value ? "" : "please enter a first name";
        tempErrors.firstName =
          value && value.trim() !== ""
            ? nameRegex.test(value.trim())
              ? ""
              : "Special characters are not allowed."
            : "Please enter a first name";
        break;
         case "lastName":
        tempErrors.lastName =
          value && value.trim() !== ""
            ? nameRegex.test(value.trim())
              ? ""
              : "Special characters are not allowed."
            : "Please enter a last name";
        break;
      //   tempErrors.lastName = value ? "" : "please enter a last name";
      case "email":
        tempErrors.email = /\S+@\S+\.\S+/.test(value) ? "" : "Email is not valid";
        break;
      case "mobileNumber":
        tempErrors.mobileNumber = /^(?:\+?\d{1,3}-?)?\d{10}$/.test(value)
          ? ""
          : "mobile Number is not valid";
        break;
      default:
        break;
    }
    setErrors(tempErrors);
  };

  const handleSubmit = async () => {
    let tempErrors = { ...errors };
    tempErrors.firstName = formData.firstName ? "" : "please enter a first name";
    tempErrors.lastName = formData.lastName ? "" : "please enter a last name";
    tempErrors.email = /\S+@\S+\.\S+/.test(formData.email)
      ? ""
      : "Email is not valid";
    tempErrors.mobileNumber = /^(?:\+?\d{1,3}-?)?\d{10}$/.test(formData.mobileNumber)
      ? ""
      : "please enter mobile phone number";
    setErrors(tempErrors);

    if (Object.values(tempErrors).some((x) => x !== "")) {

      setNotificationProps({
        type: "error",
        message: "Edit profile",
        description: "An error occurred while updating.",
        duration: 3,
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
    } else {
      const myprofile = await updateMyprofile({ ...formData });
      const activeSession = JSON.parse(sessionStorage.getItem("activeSession")) || {};
      if (myprofile && myprofile.data) {
        const updatedSession = {
          ...activeSession,
          firstName: myprofile.data.firstname,
          lastName: myprofile.data.lastname,
          userName: myprofile.data.email,
          mdn: myprofile.data.mdn
        };
        dispatch(
          updateAuth({
            key: "user",
            value: updatedSession,
          })
        );
        sessionStorage.setItem("activeSession", JSON.stringify(updatedSession));
        setNotificationProps({
          type: "success",
          message: "Edit profile",
          description: `Profile successfully Updated`,
          duration: 3,
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
          onClose();
        }, 3000);
      } else {
        setNotificationProps({
          type: "error",
          message: "Edit profile",
          description: "Profile update failed. Please check your connection and try again.",
          duration: 3,
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 3000);
      }
    }
  };

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "").replace(/^1/, "").slice(0, 10);
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 10);
    if (digits.length >= 7) {
      return `+1 ${part1}-${part2}-${part3}`;
    } else if (digits.length >= 4) {
      return `+1 ${part1}-${part2}`;
    } else if (digits.length > 0) {
      return `+1 ${part1}`;
    } else {
      return `+1`;
    }
  };
  return (
    <>
      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}
      <Modal
        visible={visible}
        title={<span className="edit-profile-title">Your Profile</span>}
        onCancel={onClose}
        footer={null}
        width={600}
      >
        <div style={{ margin: "10 auto" }}>
          <Spin spinning={isLoading} tip="Loading...">
            <div className="mb-3" style={{ marginTop: '16px' }}>
              <label htmlFor="firstName" className="input-label-user">First Name</label>
              <div className="input-container">
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={(e) => {
                    const regex = /^[A-Za-z0-9\s]*$/;
                    const rawValue = e.target.value;
                    if (regex.test(rawValue)) {
                      handleChange(e);
                    }
                  }}
                  maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                  className={getInputClassNamesUser('firstName', formData, errors)}
                  style={{ width: '100%' }}
                />
                <ValidationIcon fieldName="firstName" formData={formData} errors={errors} />
              </div>
               <div style={{ paddingTop: 5 }}>
                    <ErrorMessage fieldName="firstName" errors={errors} />
                    {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData.firstName)}
                  </div>
              {/* <ErrorMessage fieldName="firstName" errors={errors} /> */}
            </div>
            <div className="mb-3">
              <label htmlFor="lastName" className="input-label-user">Last Name</label>
              <div className="input-container">
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                   onChange={(e) => {
                      const regex = /^[A-Za-z0-9\s]*$/;
                      const rawValue = e.target.value;
                      if (regex.test(rawValue)) {
                        handleChange(e);
                      }
                    }}
                //  onChange={handleChange}
                  className={getInputClassNamesUser('lastName', formData, errors)}
                  maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                  style={{ width: '100%' }}
                />
                <ValidationIcon fieldName="lastName" formData={formData} errors={errors} />
              </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="lastName" errors={errors} />
                  {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData.lastName)}
                </div>
              {/* <ErrorMessage fieldName="lastName" errors={errors} /> */}
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="input-label-user">Email Address</label>
              <div className="input-container">
                <input
                  id="email"
                  name="email"
                  disabled
                  value={formData.email}
                  onChange={handleChange}
                  className={getInputClassNamesUser('email', formData, errors)}
                  style={{ width: '100%' }}
                />
                <ValidationIcon fieldName="email" formData={formData} errors={errors} />
              </div>
              <ErrorMessage fieldName="email" errors={errors} />
            </div>
            <div className="mb-3">
              <label htmlFor="mobileNumber" className="input-label-user">Mobile Phone</label>
              <div className="input-container">
                <input
                  id="mobileNumber"
                  name="mobileNumber"
                  value={formatPhoneNumber(formData.mobileNumber)}
                  maxLength={17}
                  onChange={(e) => {
                    const rawInput = e.target.value;
                    const digits = rawInput.replace(/\D/g, "").replace(/^1/, "").slice(0, 10);
                    const formattedValue = `+1${digits}`;
                    handleChange({
                      target: { name: "mobileNumber", value: formattedValue },
                    });
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className={getInputClassNamesUser('mobileNumber', formData, errors)}
                  style={{ width: '100%' }}
                />
                <ValidationIcon fieldName="mobileNumber" formData={formData} errors={errors} />
              </div>
              <ErrorMessage fieldName="mobileNumber" errors={errors} />
            </div>
          </Spin>

          <Grid2
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3" style={{ marginTop: '16px' }}>
                <Button
                  className="custom-button-cancel"
                  type="default"
                  onClick={onClose}
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%", }}
                  size={"large"}
                >
                  Cancel
                </Button>
              </div>
            </Grid2>

            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3" style={{ marginTop: '16px' }}>
                <Button
                  className="custom-button-save"
                  type="primary"
                  onClick={handleSubmit}
                  shape="round"
                  style={{
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                  }}
                  size={"large"}
                >
                  {"Save"}
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </div>
      </Modal>
    </>
  );
};

export default MyProfile;
